import { IRow } from '../../redux/slices/oldBuilder';
import {
  MAX_FUNCTION_PERCENTILE,
  MIN_FUNCTION_PERCENTILE,
} from '../../config/constants';
import { EventKind } from '../apollo/graphqlSchema';
import { isValidNumberWithinRange } from '../numbers';
import { byTypeName } from '../types';

type IValidateBasicMeasureArgs = Pick<
  IRow,
  'fn' | 'eventConditions' | 'percentile'
> & {
  allowedEventKinds?: EventKind[];
};

const defaultAllowedEventKinds = [
  EventKind.Any,
  EventKind.AnyTable,
  EventKind.Basic,
  EventKind.Virtual,
];

export const getEventConditionErrors = (
  fn: IRow['fn'],
  eventConditions: IRow['eventConditions'],
  allowedEventKinds: EventKind[] = defaultAllowedEventKinds,
) => {
  const errors: any = {};

  eventConditions.forEach((eventCondition, eventConditionIndex) => {
    const eventKindUsed: EventKind[] = [];

    if (eventCondition.events.filter(byTypeName('AnyEvent')).length) {
      eventKindUsed.push(EventKind.Any);
    }

    if (eventCondition.events.filter(byTypeName('AnyTableEvent')).length) {
      eventKindUsed.push(EventKind.AnyTable);
    }

    if (eventCondition.events.filter(byTypeName('BasicEventValue')).length) {
      eventKindUsed.push(EventKind.Basic);
    }

    if (eventCondition.events.filter(byTypeName('VirtualEvent')).length) {
      eventKindUsed.push(EventKind.Virtual);
    }

    if (
      !eventKindUsed.length ||
      eventKindUsed.some((eventKind) => !allowedEventKinds.includes(eventKind))
    ) {
      errors.events = {
        ...(errors?.events || {}),
        [eventConditionIndex]: true,
      };
    }

    if (fn?.fieldRequired && !eventCondition.field) {
      errors.fields = {
        ...(errors?.fields || {}),
        [eventConditionIndex]: true,
      };
    }
  });

  return errors;
};

export const getBasicMeasureRowErrors = ({
  fn,
  eventConditions,
  percentile,
  allowedEventKinds = defaultAllowedEventKinds,
}: IValidateBasicMeasureArgs) => {
  const errors: any = {};

  if (!fn.name) {
    errors.fn = true;
  }

  if (
    fn.requirePercentile &&
    !isValidNumberWithinRange(
      percentile,
      MIN_FUNCTION_PERCENTILE,
      MAX_FUNCTION_PERCENTILE,
    )
  ) {
    errors.percentile = true;
  }

  const eventConditionErrors = getEventConditionErrors(
    fn,
    eventConditions,
    allowedEventKinds,
  );

  return {
    ...errors,
    ...eventConditionErrors,
  };
};
